import { useCreatePrintActionHistoryRecordMutation } from '../../redux/api/printableApi'
import { PrintActionInfoMethodEnum } from '../../sdk'

const usePrintActionNowForMethod = (
  repairOrderId: string | undefined,
  accessToken: string
) => {
  const [createPrintAction] = useCreatePrintActionHistoryRecordMutation()
  return async (method: PrintActionInfoMethodEnum) => {
    await createPrintAction({
      authorization: accessToken,
      printActionInfo: {
        repairOrderId,
        method,
        dateTime: new Date()
      }
    })
  }
}

export default usePrintActionNowForMethod
